'use client'

import { QuotePopup } from "@webbeukers/wb-library.package";

const NPM_QuotePopup = QuotePopup;

export default NPM_QuotePopup;